export default "__VITE_ASSET__ReaY0rxK__"